webpackJsonp([35783957827783],{

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Opensans-Bold.50145685.ttf";

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Opensans-Italic.c7dcce08.ttf";

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Opensans-Light.1bf71be1.ttf";

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Opensans-LightItalic.6943fb6f.ttf";

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Opensans-Regular.629a55a7.ttf";

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Opensans-Semibold.33f225b8.ttf";

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Opensans-SemiboldItalic.73f7301a.ttf";

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @font-face {\n    font-family: \'OpensansBold\';\n    font-style: normal;\n    font-weight: bold;\n    src: local(\'OpensansBold\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansRegular\';\n    font-style: normal;\n    font-weight: regular;\n    src: local(\'OpensansRegular\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansItalic\';\n    font-style: italic;\n    font-weight: regular;\n    src: local(\'OpensansItalic\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansLightItalic\';\n    font-style: italic;\n    font-weight: regular;\n    src: local(\'OpensansLightItalic\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansLight\';\n    font-style: noraml;\n    font-weight: regular;\n    src: local(\'OpensansLight\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansSemibold\';\n    font-style: normal;\n    font-weight: bold;\n    src: local(\'OpensansSemibold\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansSemiboldItalic\';\n    font-style: italic;\n    font-weight: bold;\n    src: local(\'OpensansSemiboldItalic\'), url(', ') format(\'truetype\');\n  }\n'], ['\n  @font-face {\n    font-family: \'OpensansBold\';\n    font-style: normal;\n    font-weight: bold;\n    src: local(\'OpensansBold\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansRegular\';\n    font-style: normal;\n    font-weight: regular;\n    src: local(\'OpensansRegular\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansItalic\';\n    font-style: italic;\n    font-weight: regular;\n    src: local(\'OpensansItalic\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansLightItalic\';\n    font-style: italic;\n    font-weight: regular;\n    src: local(\'OpensansLightItalic\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansLight\';\n    font-style: noraml;\n    font-weight: regular;\n    src: local(\'OpensansLight\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansSemibold\';\n    font-style: normal;\n    font-weight: bold;\n    src: local(\'OpensansSemibold\'), url(', ') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'OpensansSemiboldItalic\';\n    font-style: italic;\n    font-weight: bold;\n    src: local(\'OpensansSemiboldItalic\'), url(', ') format(\'truetype\');\n  }\n']);
	
	var _OpensansBold = __webpack_require__(525);
	
	var _OpensansBold2 = _interopRequireDefault(_OpensansBold);
	
	var _OpensansRegular = __webpack_require__(529);
	
	var _OpensansRegular2 = _interopRequireDefault(_OpensansRegular);
	
	var _OpensansItalic = __webpack_require__(526);
	
	var _OpensansItalic2 = _interopRequireDefault(_OpensansItalic);
	
	var _OpensansLight = __webpack_require__(527);
	
	var _OpensansLight2 = _interopRequireDefault(_OpensansLight);
	
	var _OpensansLightItalic = __webpack_require__(528);
	
	var _OpensansLightItalic2 = _interopRequireDefault(_OpensansLightItalic);
	
	var _OpensansSemibold = __webpack_require__(530);
	
	var _OpensansSemibold2 = _interopRequireDefault(_OpensansSemibold);
	
	var _OpensansSemiboldItalic = __webpack_require__(531);
	
	var _OpensansSemiboldItalic2 = _interopRequireDefault(_OpensansSemiboldItalic);
	
	var _styledComponents = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = {
	  OpensansBold: _OpensansBold2.default,
	  OpensansRegular: _OpensansRegular2.default,
	  OpensansItalic: _OpensansItalic2.default,
	  OpensansLight: _OpensansLight2.default,
	  OpensansLightItalic: _OpensansLightItalic2.default,
	  OpensansSemibold: _OpensansSemibold2.default,
	  OpensansSemiboldItalic: _OpensansSemiboldItalic2.default
	};
	
	
	(0, _styledComponents.injectGlobal)(_templateObject, _OpensansBold2.default, _OpensansRegular2.default, _OpensansItalic2.default, _OpensansLightItalic2.default, _OpensansLight2.default, _OpensansSemibold2.default, _OpensansSemiboldItalic2.default);
	module.exports = exports['default'];

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABSCAYAAAAo7uilAAAACXBIWXMAAAsSAAALEgHS3X78AAAEbklEQVR42u2d/3WbMBDHv+blf9MJTCcwnSDOBPEIjOAN6k5Qj0A3IBvQCUomKExQPIH6R06OfOG3MRLh7j09Ow7G0oc73emQxEopBYviAwgB7AAEVEIA65bvnQFkAHIqKf1d2mzMygLMEMCeynbkc78S2JjgfkqYAYADAdxU/L8wNKzsACI0tDpsOGcC4ETnvr8ope5ZdkqpRH2UXCkVK6X2Sil/hN/x6VwxnZtLSnW5a3vvCTFlDSqpseG9G0W/caLfnAzq2CcMKjQxV0pFI2ngkBJVaGtKdXUW5pFpgoYIR0oV1KNrMANm0qVS6uAQRF4O7KJnY2nprSfYs4olFs25r8NKmALsbcI8sspEM4BYZfrlWGY/9IsxM5NwhiBNz58Z7YmnhBkzr+jPGKRp9umtQG8BGX8CiKO2T0CO2M4+4cQSQFYBPY4Jc8/6SCykmH1op7CpLWsUUAZnTemtne2c4cS51pTShGfKTjVmn7yWE8YE8gwgWhBIUFsjavua0nkYCvMA4NF4n2F5klHbQRp6HJIcNs37hZK6S5YEwDO9/1pn7nUw9Zc79RUL6T9zUq7f5Ds6mfnOuApHAXnpP7WJP9bBrNLMlL5QkLm7pB2+5Yub0/2mSu30KrTy0dBK2xJR360A/APwl97rUtLFP0xUn2btZIFnYmTJbSceMtVdphxM5HW/6TEP/uyIVqY976mnE9bN1M6gzswjY7ZEYtm0twP6sqkkJkbg3UsVzMTySCca6BgwMVDw+Ft78xDAH/rsm+XRTon2uUYFeXZ93MrCFJ8PvDxGuHBg2NgE8gXAF+qrfIL4ZGmYWXBL4jBTuC2nii7IVp0TI5y8grllB4h0jyC2ZCXwWPCZCaNB4VjIYRYyDu/tKAvT1B+MwNMWSD3XsuuxtoN27og2mqEJ01aFTkY+oE1+1ny+sgjzWTP0DJilWO7gwcKlz9zM3PmcHYC55sPJuYozSuCJpY4m/oMDlYiZ8/vecOyviqgjd8QqwpV6v2/x5MhwsmlWhCt1vGgj3u4AAMCTmPntMfIl1hWY4oDchVm0DNVE6iUwY13P8Ia+sBkMM+Mwd8JmsAPKOcxA2NwOU8dtGwHaO8bUeY2UwxQn1E92fCSkQ6NXet0Lo94wX0HpSw0zESfUWz7c0eUwN2LqnR2P7i9jDtO8qX4QVq0S0evVpA1zOBkb6isBfDeYSd3YXMNciyNqBamn8JzqYOZ4m8sDuDFr2FXRbH6DJaZ51uhkOKJIuFVq5aZO4ea0QMAFydFjgYBJfCOe/UoOTVpZp5naS8miqutxeI4Bi6r0VdALME+ilJcFuWjyJV5D36BV+XnhzijC+yqUH01W2rbeXDujM6n20uZvhsRAr7dvHGrL4v3mfjLFiIv3c8PEt1jWNO0E79PTo05OWDY8mXbDE9mKRzaJcnuTKNm+TDbWc3tjvSqnJFs+ymak7mxGKtvkygbOVxfduQ2cZWtx2fR+Pk8QWOTjGORBISOKPMJm5jB5zvDTPFzpPwxJGh69z9ROAAAAAElFTkSuQmCC"

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABSCAYAAAAo7uilAAAACXBIWXMAAAsSAAALEgHS3X78AAAFRUlEQVR42u1d3ZXiNhT+hsM73gpwBzgV4K1g2QpCKlinA7aC9VawngriVBBPB54OTAUxFSgPXM3cEbItiGQZrHuOzmAGbOnT/Zd0eRJCwDOl1GLW1gPfOQGoATTUKrpufQ7kyQOYCYAdtY3le78SsAWB+5BgxgD21HRcd2Qc1hoAkQCI6G/Sc88SQE73dk9CCJctFUKU4pIaIUQhhNgJIWILz4noXjndW6WK+uJ0vC5BrJQBtQRg4npQ9IycnjkaqLZvGBNgKhfuiXvgoe013FpZkghnYGYKJ0gQMZGWakA9TA3MSBHp1nYnHXAqn/TaluqxMduta/Fx0CLFMLY2pOj/zjDvTHYHIKptpzBD7gPMQtGNyR0CyY1mzcZTjAlmoeib6I6B5GJfKOoqcg1moczgIwDZNb7KJZiFDVG4M0ALF2DuZwKkDtDcJpjpA+rIawE1cpuGskYRZVxWlIVJfOcMR6SIslgbyp+mQ9msxcANSwISlH+cC5Cgse4IyBXlSHErmBmALb3+00eydQLUUA4WxKGHW5LDXLxfiMXnTCWAL/T6ty7G6uLMnIA8sZmZM+0JC4mNsZgnAH5nX2wClmhJ7YFU385UzCv6wtystwnVpDuPtK7Vy5kJMzoHy0CmpHvESK10oOsld6616q/DUW0sO8C58Ee2I7aqK3ZXMyeSsgcB0gWgPLROusDM2IdshYypmA7tLALa6CZpqZh/AHi2qCvHcqs+d3glP9j1gfSoLb/z24VVZ9lmFzPYjsR1plJhMzt/gdeCxd1yQ1RpkWNWE3NtbFn3hvY1fbinCmaJQKZUKdi9gblVPhDITG9KnzOWYKYatAOZc6Y0dljKF6QvmwcYGM98uaZXCi8TAOWSxZhTzVe+kqu27fnM1nOsnkoxTyYI5gnAHwA+Uf9SAE/03nFiyeM3KVgoaaapcGKM8zKB2qeCwH2ZUBYJxJ1YMhFxzZlHXK6jJCyDLTkyHZhYuTZT4+P26xeN7kwdq4AP/VyOyJkNLtdQCk2KqzUcRAbgL+X9g+Z6LH0aLTyLSdzhu5n6eSfVPfHpHvkGc6uogWulo55S6OobzIci32Byq7y+wdFOApiXfhrUpIEB7RTR9uEu8VC8XowcfmHA4OSG/Yg0ltt3xqtdsBlNPIF5VIxINQBoRC7VRvFPCw/9j7rEPPI0o5lyvcH7Hh+1T3uy4F80/qSPCC5hURsWzL3wpcxLAD+V91YAfgH4l/pX4bwW/guXh06f0bNlZSQ/uZURUDMByyi585vmf33HqJ/hdy9Uwp13zpkrTUQyNqBfYZYVOuG8zdEnkHyiawlm1WHqfYl8jHOq7VkB9gjgb/pf7FG0tW4RT3S8UGiXerKK0CRAptCPIT9XTnLDrXl5g9N8DxSPwJml6hqVTG/aBPSkJDXG1MmRZiy1xUnacOPDwWzwvqhuE8yyQyeOAWSphJuvFn3RjDHL2xj5ZtcM73tzPll6cArgn4EEhyuXRU3JfbUYcjbk7350zcKWQjdbCsNmV4ubXWXVlauOuFkoy+OKSgeVYtI+fMIBgevoqgMC3FKtNRmdOdOeuUNaXLpOqBU4nwU6EXc2MwfS6MReOO5n7i/ffNyvxfuywHbm4r5jQH7vi6KGzptLY9Q7Iw9MMY15RRFUb853YTArJ8bq0YyA5CGp0YHcITBbFquvMbzY9UiUK9Z7WCpDwZNxC56EUjyhSNS0i0SF8mWhsN60C+vpjJLtHOisSj6GYqShTO60y+SGAs6htPj0S4uHovfh5xjstfBDIRYp/ITNnYOp2/WR4gF+XOk/Dq0LmWaWUcMAAAAASUVORK5CYII="

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden !important;\n'], ['\n  position: fixed;\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden !important;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 5;\n  width: 100vw;\n  height: 15vw;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0.7),\n    rgba(0, 0, 0, 0.5),\n    rgba(0, 0, 0, 0)\n  );\n'], ['\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 5;\n  width: 100vw;\n  height: 15vw;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0.7),\n    rgba(0, 0, 0, 0.5),\n    rgba(0, 0, 0, 0)\n  );\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 5;\n  width: 100vw;\n  height: 35vw;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0.6),\n    rgba(0, 0, 0, 0.3),\n    rgba(0, 0, 0, 0)\n  );\n'], ['\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 5;\n  width: 100vw;\n  height: 35vw;\n  background: linear-gradient(\n    rgba(0, 0, 0, 0.6),\n    rgba(0, 0, 0, 0.3),\n    rgba(0, 0, 0, 0)\n  );\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden !important;\n  z-index: 1;\n'], ['\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden !important;\n  z-index: 1;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(37);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _reactSlick = __webpack_require__(79);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _slide = __webpack_require__(82);
	
	var _slide2 = _interopRequireDefault(_slide);
	
	var _api = __webpack_require__(25);
	
	__webpack_require__(264);
	
	__webpack_require__(515);
	
	__webpack_require__(514);
	
	var _instagramWhite = __webpack_require__(643);
	
	var _instagramWhite2 = _interopRequireDefault(_instagramWhite);
	
	var _facebookWhite = __webpack_require__(641);
	
	var _facebookWhite2 = _interopRequireDefault(_facebookWhite);
	
	var _reactResponsive = __webpack_require__(24);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Mobile = function Mobile(props) {
	  return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { maxWidth: 767 }));
	};
	var Desktop = function Desktop(props) {
	  return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { minWidth: 992 }));
	};
	
	var settings = {
	  dots: false,
	  arrows: false,
	  fade: true,
	  infinite: true,
	  speed: 500,
	  autoplay: true,
	  lazyLoad: true,
	  swipe: false,
	  slidesToShow: 1,
	  slidesToScroll: 1
	};
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	var NavigationDimmer = _styledComponents2.default.div(_templateObject2);
	var NavigationDimmerMobile = _styledComponents2.default.div(_templateObject3);
	var SliderStyled = (0, _styledComponents2.default)(_reactSlick2.default)(_templateObject4);
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Home);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      slides: [],
	      current: 0
	    }, _this.componentDidMount = function () {
	      (0, _api.getIntroSlideshow)().then(function (content) {
	        var slides = content.slideshow;
	
	        _this.setState({ slides: slides });
	      });
	    }, _this._navigate = function (slides) {
	      var target = slides[_this.state.current].url;
	
	      //TODO: fix this
	      var location = target.replace('http://www.burlemarx.monographics.org', '');
	      (0, _gatsbyLink.push)('' + location + window.location.search);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Home.prototype.render = function render() {
	    var _this2 = this;
	
	    var slides = this.state.slides;
	
	    return _react2.default.createElement(
	      _gatsbyPluginPageTransitions2.default,
	      null,
	      _react2.default.createElement(
	        Wrapper,
	        { onClick: function onClick() {
	            return _this2._navigate(slides);
	          } },
	        _react2.default.createElement(
	          SliderStyled,
	          _extends({}, settings, {
	            afterChange: function afterChange(currentSlide) {
	              _this2.setState({ current: currentSlide });
	            }
	          }),
	          slides.map(function (slide, index) {
	            var image = slide.image,
	                url = slide.url;
	            // console.log(image, url)
	
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_slide2.default, { image: image, url: url, key: index })
	            );
	          })
	        ),
	        _react2.default.createElement(
	          Desktop,
	          null,
	          _react2.default.createElement(NavigationDimmer, null)
	        ),
	        _react2.default.createElement(
	          Mobile,
	          null,
	          _react2.default.createElement(NavigationDimmerMobile, null)
	        ),
	        _react2.default.createElement(
	          Desktop,
	          null,
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                position: 'absolute',
	                left: '5vw',
	                zIndex: 5,
	                bottom: '2vh'
	              }
	            },
	            _react2.default.createElement('img', {
	              src: _instagramWhite2.default,
	              style: {
	                width: '41px',
	                height: '41px',
	                zIndex: 5,
	                marginTop: '20px'
	              },
	              onClick: function onClick() {
	                return window.open('https://www.instagram.com/escritorioburlemarx/', '_blank');
	              }
	            }),
	            _react2.default.createElement('img', {
	              src: _facebookWhite2.default,
	              style: {
	                width: '41px',
	                height: '41px',
	                marginLeft: '20px'
	              },
	              onClick: function onClick() {
	                return window.open('https://www.facebook.com/escritorioburlemarx/', '_blank');
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          Mobile,
	          null,
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                position: 'fixed',
	                left: '10vw',
	                bottom: '2vh',
	                zIndex: 5
	              }
	            },
	            _react2.default.createElement('img', {
	              src: _instagramWhite2.default,
	              style: { width: '41px', height: '41px', marginTop: '20px' },
	              onClick: function onClick() {
	                return window.open('https://www.instagram.com/escritorioburlemarx/', '_blank');
	              }
	            }),
	            _react2.default.createElement('img', {
	              src: _facebookWhite2.default,
	              style: {
	                width: '41px',
	                height: '41px',
	                marginLeft: '20px'
	              },
	              onClick: function onClick() {
	                return window.open('https://www.facebook.com/escritorioburlemarx/', '_blank');
	              }
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react.Component);
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4431ff4452a12c3f9d7f.js